import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../../../utils/Utils";
import Calendar from "../../../../../../../components/calendar/Calendar";
import $ from "jquery";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json"

class Ricovero extends Component {

    state = {
        ricovero: {
            valore: "",
            dataRicovero: "",
            dataDimissione: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.disabledCalendar = this.disabledCalendar.bind(this)
        this.validate = this.validate.bind(this);

    }

    componentDidMount() {
        let ricovero = this.state.ricovero
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.ricovero) {
            let ricoveroCopia = this.props.segnalazioneCopia.schedaSpeciale.ricovero
            for (let key in ricovero) {
                if (ricovero.hasOwnProperty(key) === ricoveroCopia.hasOwnProperty(key)) {
                    ricovero[key] = ricoveroCopia[key]
                } else {
                    ricovero[key] = ""
                }
            }
            this.setState({ricovero: ricovero})
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("ricovero", oggettoBE, corretto)
            this.disabledCalendar()

        } else if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.datiSanitari) {
            if (this.props.segnalazioneCopia.datiSanitari.dataRicovero) {
                ricovero.dataRicovero = this.props.segnalazioneCopia.datiSanitari.dataRicovero
            }
            if (this.props.segnalazioneCopia.datiSanitari.dataDimissione) {
                ricovero.dataDimissione = this.props.segnalazioneCopia.datiSanitari.dataDimissione
            }
            if (this.props.segnalazioneCopia.datiSanitari.ricovero && this.props.segnalazioneCopia.datiSanitari.ricovero === "0") {
                ricovero.valore = "3"
            } else {
                ricovero.valore = this.props.segnalazioneCopia.datiSanitari.ricovero
            }
            ricovero.dataRicovero = Utils.transformDateForFrontend(ricovero.dataRicovero)
            ricovero.dataDimissione = Utils.transformDateForFrontend(ricovero.dataDimissione)
            this.setState({ricovero: ricovero})
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("ricovero", oggettoBE, corretto)
            this.disabledCalendar()
        } else {
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("ricovero", oggettoBE, corretto)
            this.disabledCalendar()
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledCalendar()
    }

    validate() {

        if (this.state.ricovero.dataDimissione && Utils.validateDate(this.state.ricovero.dataDimissione, "Messages.DataDimissioni", "Messages.DataDimissioniOdierna")) {
            return Utils.validateDate(this.state.ricovero.dataDimissione, "Messages.DataDimissioni", "Messages.DataDimissioniOdierna")
        }
        if (this.state.ricovero.dataRicovero && Utils.validateDate(this.state.ricovero.dataRicovero, "Messages.DataRicovero", "Messages.DataRicoveroOdierna")) {
            return Utils.validateDate(this.state.ricovero.dataRicovero, "Messages.DataRicovero", "Messages.DataRicoveroOdierna")
        }

        return ""

    }

    disabledCalendar() {
        if (this.state.ricovero.valore !== "1") {
            $(document).ready(function () {
                $("#dataDimissione").datepicker('disable');
                $("#dataRicovero").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataDimissione").datepicker('enable');
                $("#dataRicovero").datepicker('enable');
            })
        }
    }

    riceviValore(field, event) {
        let ricovero = this.state.ricovero
        ricovero[field] = event.target.value
        if (ricovero.valore !== "1") {
            ricovero.dataRicovero = ""
            ricovero.dataDimissione = ""
        }
        this.setState({ricovero: ricovero})
        let corretto = this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        this.props.createOggettoBeAndcontrolloCorrettezza("ricovero", oggettoBE, corretto, this.validate())
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.ricovero))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    controlloCorrettezza() {
        let ricovero = this.state.ricovero
        ricovero.corretto = []

        if (ricovero.valore === "1") {
            if (!ricovero.dataRicovero || Utils.isDateInValid(Utils.transformDateForBackend(ricovero.dataRicovero), "-")) ricovero.corretto[0] = "Campo \"Data ricovero\" mancante o errato";
            if (!ricovero.dataDimissione || Utils.isDateInValid(Utils.transformDateForBackend(ricovero.dataDimissione), "-")) ricovero.corretto[1] = "Campo \"Data dimissione\" mancante o errato";
        }

        return ricovero.corretto

    }


    render() {

        const {t} = this.props

        const ricovero = (
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-2"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.ricovero")}
                        </p>
                    </div>
                    <div className={"col-lg-9"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"ricoveroSi"} name={"valore"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"1"}
                                             checked={this.state.ricovero.valore === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-5"}>
                                <RadioButton id={"ricoveronoSoloVisita"} name={"valore"}
                                             label={t("SchedaSpecialeMorbillo.noSoloVisita")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.ricovero.valore === "2"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"ricoveroNo"} name={"valore"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"3"}
                                             checked={this.state.ricovero.valore === "3"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>

                </div>
                <div className={"row"}>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p style={{marginTop: "0.5rem", color: "#1b7ea9"}}>
                            {t("SchedaSpecialeMorbillo.dataRicovero")}
                            {this.state.ricovero.valore === "1" ? <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                        <div>
                            <Calendar
                                id={"dataRicovero"}
                                value={this.state.ricovero.dataRicovero}
                                field={"dataRicovero"}
                                newCalendar={true}
                                onChange={this.riceviValore}
                                disabled={this.state.ricovero.valore !== "1" ? true : false}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataRicovero"))}
                                error={(this.state.ricovero.dataRicovero === "" || this.state.ricovero.dataRicovero == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.ricovero.dataRicovero), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <p style={{marginTop: "0.5rem", color: "#1b7ea9"}}>
                            {t("SchedaSpecialeMorbillo.dataDimissione")}
                            {this.state.ricovero.valore === "1" ? <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                        <div>
                            <Calendar
                                id={"dataDimissione"}
                                value={this.state.ricovero.dataDimissione}
                                field={"dataDimissione"}
                                newCalendar={true}
                                onChange={this.riceviValore}
                                disabled={this.state.ricovero.valore !== "1" ? true : false}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataDimissione"))}
                                error={(this.state.ricovero.dataDimissione === "" || this.state.ricovero.dataDimissione == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.ricovero.dataDimissione), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </div>
                </div>
            </div>
        )


        return (
            <div style={{marginTop: "2rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.ricovero")}</h6>
                <hr className={styles.hr}/>
                {ricovero}
            </div>
        );
    }


}

export default withTranslation('common')(Ricovero)

